module.exports = __webpack_public_path__ + "img/mession.36e1d814.png";